<template>
    <router-view v-if="this.$isAdmin()"></router-view>
</template>

<script>
export default {
    beforeCreate() {
        if (!this.$isAdmin()) {
            this.$router.back()
        }   
    }
}
</script>